import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(value: number) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(value);
}

export function lookLabel(lookNumber: number) {
  return `Look ${String(lookNumber).padStart(2, "0")}`;
}

export function garmentLabel(type: "top" | "bottom" | "saree" | "frock" | "outfit") {
  if (type === "top") return "Top Wear";
  if (type === "bottom") return "Bottom Wear";
  if (type === "saree") return "Saree";
  if (type === "frock") return "Frock";
  return "Complete Outfit";
}
